import { Button } from "@/components/ui/button";

// Free of @/hooks/use-api (no supabase import) so it renders in tests without
// env vars — the container owns data-fetching and passes plain props.

export function CalendarMonthEmpty({
  monthLabel,
  nearest,
  onJump,
}: {
  monthLabel: string;
  nearest: { year: number; month: number; count: number; label: string } | null;
  onJump: (target: { year: number; month: number }) => void;
}) {
  return (
    <div className="mb-3 flex items-center justify-between gap-3 rounded-lg border border-[color:var(--color-border)] bg-[color:var(--color-surface)] px-4 py-3">
      <p className="typo-label normal-case tracking-normal text-[color:var(--color-text-lo)]">
        No jobs scheduled in {monthLabel}.
      </p>
      {nearest && (
        <Button
          variant="outline"
          size="sm"
          onClick={() => onJump({ year: nearest.year, month: nearest.month })}
        >
          Jump to {nearest.label} ({nearest.count}{" "}
          {nearest.count === 1 ? "job" : "jobs"})
        </Button>
      )}
    </div>
  );
}
